import React, { useEffect, useMemo, useRef, useState } from "react";
import { Card, CardBody, Container, Modal, ModalBody, ModalFooter, ModalHeader, Button,  Col, Label, Input, Row, InputGroup, InputGroupText,
} from "reactstrap";

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainer from "../../components/Common/TableContainer";

// API helper and URL helper
import { get, del, put } from "../../helpers/api_helper";
import {
  DELETE_FILLER,
  FILLER_LIST,
  UPDATE_FILLER,
  NOZZLE_LIST,
} from "../../helpers/url_helper";

// Toaster
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// React Router
import { useNavigate } from "react-router-dom";
import fillerColumns from "components/Columns/FillerColumns";
import {
  Controller,
  useForm,
} from "react-hook-form";

const Fillers = () => {
  const breadcrumbItems = [
    { title: "valfuel", link: "/" },
    { title: "Fillter", link: "#" },
  ];

  const [Fillers, seFillers] = useState([]);

  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [sortBy, setSortBy] = useState([]);

  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedFiller, setSelectedFiller] = useState(null);
  const [fillerToEdit, setFillerToEdit] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [nozzelList, setNozzelList] = useState(null);
  const updateFiller = (id, data) => put(UPDATE_FILLER(id), data);
  const navigate = useNavigate();

  async function getNozzleList(page, size, sort = [], search = "") {
    const sortKey = sort[0]?.id;
    const sortby = sort[0]?.desc ? "desc" : "asc";
    return await get(FILLER_LIST, {
      params: { page, size, sortKey, sortby },
    });
  }

  const fetchNozzelList = async () => {
    try {
      const response = await get(NOZZLE_LIST); // Update if paginated
      setNozzelList(response.data.items || []);
    } catch (err) {
      console.error("Failed to fetch nozzles", err);
    }
  };

  const {
    register,
    handleSubmit,
    control,
    setValue,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      phone: "",
      name: "",
      password: "",
      email: "",
      // Salary: "",
      // nozzle: "",
      notes: "",
      status: "1",
      // nozzel: "",
    },
  });

  const fetchFillters = async (
    page = 1,
    size = 10,
    sortBy = [],
    searchText = ""
  ) => {
    try {
      setLoading(true);
      const response = await getNozzleList(page, size, sortBy, searchText);
      const { items, totalPages } = response.data;

      seFillers(items);
      setTotalPages(totalPages);
    } catch (error) {
      console.error("Failed to fetch Fillters:", error);
    } finally {
      setLoading(false);
    }
  };
  const toggleEditModal = () => {
    setEditModalOpen(!editModalOpen);
    if (editModalOpen) reset();
  };

  const handleEdit = async (item) => {
    await fetchNozzelList();

    setFillerToEdit(item);
    reset({
      phone: item.phone || "",
      name: item.name || "",
      email: item.email || "",
      status: item.status || "1",
      // nozzel: item.nozzel || "",
      password: "",
      Liter: item.Liter || "",
      notes: item.notes || "",
    });
    setShowPasswordField(false);
    setEditModalOpen(true);
  };
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const onSubmitEdit = async (data) => {
    try {
      await updateFiller(fillerToEdit.ul_id, data);
      toastr.success("Filler updated successfully!");
      fetchFillters();
      setEditModalOpen(false); // ✅ close modal after save
      reset(); // ✅ reset form after save
    } catch (error) {
      toastr.error("Failed to update Filler.");
      console.error(error);
    }
  };

  const handleDelete = (item) => {
    setSelectedFiller(item);
    setModalOpen(true);
  };

  const confirmDelete = async () => {
    try {
      if (selectedFiller) {
        await del(DELETE_FILLER(selectedFiller.ul_id)); // Call delete API
        toastr.success("Filler deleted successfully!");
        fetchFillters(pageIndex, pageSize, sortBy, searchText);
      }
    } catch (error) {
      console.error(
        "Failed to delete Filler:",
        error?.response?.data || error?.message
      );
      toastr.error("Something went wrong while deleting.");
    }
    setModalOpen(false);
  };

  const handleSearchChange = (text) => {
    setPageIndex(1);
    setSearchText(text);
  };

  useEffect(() => {
  fetchFillters(pageIndex, pageSize, sortBy, searchText);
}, [pageIndex, pageSize, sortBy, searchText]);

  const columns = useMemo(() => fillerColumns(handleEdit, handleDelete), []);
  const [showPasswordField, setShowPasswordField] = useState(false);
  const passwordRef = useRef(null);
  const handleCopyPassword = async () => {
  const password = getValues("password"); // from useForm()

  if (!password) {
    toastr.warning("No password to copy");
    return;
  }

  try {
    await navigator.clipboard.writeText(password);
    toastr.success("Password copied to clipboard!");
  } catch (err) {
    toastr.error("Failed to copy password");
    console.error("Clipboard copy failed:", err);
  }
};

  const handleChangePasswordClick = () => {
    setShowPasswordField(true);
    setTimeout(() => {
      passwordRef.current?.focus();
    }, 100); // Wait for input to render
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Filler" breadcrumbItems={breadcrumbItems} />
        </Container>

        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={Fillers}
              isPagination={true}
              customPageSize={pageSize}
              iscustomPageSize={false}
              isGlobalFilter={true}
              isBordered={false}
              controlledPagination={{
                pageIndex,
                setPageIndex,
                pageSize,
                setPageSize,
                totalPages,
              }}
              onSortChange={setSortBy}
              searchText={searchText}
              onSearchChange={handleSearchChange}
              isAddOptions={true}
              addOptionTitle={"Add New Filler"}
              handleAddClick={() => navigate("/add-filler")} // adjust path to match your route
            />
          </CardBody>
        </Card>
      </div>
      {/* Delete Confirmation Modal */}
      <Modal isOpen={modalOpen} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>
          Confirm Deletion
        </ModalHeader>
        <ModalBody>Are you sure you want to delete this nozzle permanently?</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
          <Button color="danger" onClick={confirmDelete}>
            Yes, Delete
          </Button>
        </ModalFooter>
      </Modal>
      <Modal size="lg" isOpen={editModalOpen} toggle={toggleEditModal}>
        <ModalHeader toggle={toggleEditModal}>Edit Filler</ModalHeader>
        <ModalBody>
          <form onSubmit={handleSubmit(onSubmitEdit)}>
            <Row>
              {/* Phone Number */}
              <Col md="6" xl="4">
                <div className="mb-3 position-relative">
                  <Label htmlFor="phone">
                    Phone No <span className="text-danger">*</span>
                  </Label>
                  <Controller
                    name="phone"
                    control={control}
                    rules={{
                      required: "Phone number is required",
                      pattern: {
                        value: /^[0-9]*$/,
                        message: "Please enter only numbers",
                      },
                      minLength: {
                        value: 10,
                        message: "Must be 10-digits phone number",
                      },
                      maxLength: {
                        value: 10,
                        message: "Must be 10-digits phone number",
                      },
                    }}
                    render={({ field }) => (
                      <Input
                        {...field}
                        type="tel"
                        id="phone"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength="10"
                        placeholder="Enter Phone no"
                        className={`form-control ${errors.phone ? "is-invalid" : ""
                          }`}
                        onKeyDown={(e) => {
                          if (
                            !/[0-9]|Backspace|ArrowLeft|ArrowRight|Tab|Delete/.test(
                              e.key
                            )
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    )}
                  />
                  {errors.phone?.message && (
                    <div className="text-danger">{errors.phone.message}</div>
                  )}
                </div>
              </Col>

              {/* Name */}
              <Col md="6" xl="4">
                <div className="mb-3 position-relative">
                  <Label htmlFor="name">
                    Name <span className="text-danger">*</span>
                  </Label>
                  <Controller
                    name="name"
                    control={control}
                    rules={{ required: "Name is required" }}
                    render={({ field }) => (
                      <Input
                        {...field}
                        type="text"
                        id="name"
                        placeholder="Enter name"
                        className={`form-control ${errors.name ? "is-invalid" : ""
                          }`}
                      />
                    )}
                  />
                  {errors.name?.message && (
                    <div className="text-danger">{errors.name.message}</div>
                  )}
                </div>
              </Col>
              <Col md="6" xl="4">
                <div className="mb-3 position-relative">
                  <Label htmlFor="name">
                    Email <span className="text-danger">*</span>
                  </Label>
                  <Controller
                    name="email"
                    control={control}
                    rules={{ required: "email is required" }}
                    render={({ field }) => (
                      <Input
                        {...field}
                        type="email"
                        id="email"
                        placeholder="Enter email"
                        className={`form-control ${errors.email ? "is-invalid" : ""
                          }`}
                      />
                    )}
                  />
                  {errors.name?.message && (
                    <div className="text-danger">{errors.name.message}</div>
                  )}
                </div>
              </Col>

              {/* Password + Copy */}
              <Col md="6" xl="4">
                <div className="mb-3 position-relative">
                  <Label htmlFor="password">
                    Password <span className="text-danger">*</span>
                  </Label>

                  {!showPasswordField ? (
                    <div>
                      <Button
                        color="secondary"
                        size="sm"
                        onClick={handleChangePasswordClick}>
                        Change Password
                      </Button>
                    </div>
                  ) : (
                    <InputGroup>
                      <Controller
                        name="password"
                        control={control}
                        rules={{ required: "Password is required" }}
                        render={({ field }) => (
                          <Input
                            {...field}
                            innerRef={passwordRef}
                            type="password"
                            id="password"
                            placeholder="Enter new password"
                            className={`form-control ${errors.password ? "is-invalid" : ""
                              }`}
                          />
                        )}
                      />
                      <InputGroupText
                        onClick={handleCopyPassword}
                        style={{ cursor: "pointer" }}
                        title="Copy Password"
                      >
                        <i className="mdi mdi-content-copy" />
                      </InputGroupText>
                    </InputGroup>
                  )}

                  {errors.password?.message && (
                    <div className="text-danger">{errors.password.message}</div>
                  )}
                </div>
              </Col>


              {/* Filler Status */}
              <Col md="6" xl="4">
                <div className="mb-3 position-relative">
                  <Label htmlFor="status">Status</Label>
                  <Controller
                    name="status"
                    control={control}
                    render={({ field }) => (
                      <Input type="select" {...field} id="filler_status">
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </Input>
                    )}
                  />
                </div>
              </Col>

              {/* Remarks */}
              <Col md="12" xl="6">
                <div className="mb-3 position-relative">
                  <Label htmlFor="remarks">Remarks</Label>
                  <Controller
                    name="notes"
                    control={control}
                    render={({ field }) => (
                      <Input
                        {...field}
                        type="textarea"
                        id="notes"
                        style={{ height: "80px" }}
                        placeholder="Enter Remarks"
                      />
                    )}
                  />
                </div>
              </Col>
            </Row>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleEditModal}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleSubmit(onSubmitEdit)}>
            Save Changes
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default Fillers;
